<template>
  <div>
    <div class="title-level">
      <h1 class="title">Orders</h1>

      <vs-select class="filter" label="Product" placeholder="Select" v-model="selectedFilter">
        <vs-option v-for="filter in filters" :key="filter" :label="filter" :value="filter">{{ filter }}</vs-option>
      </vs-select>
    </div>

    <vs-table striped>
      <template #thead>
        <vs-tr>
          <vs-th sort @click="orders = $vs.sortData($event, orders, 'id')">PO</vs-th>
          <vs-th sort @click="orders = $vs.sortData($event, orders, 'contents')">Contents</vs-th>
          <vs-th sort @click="orders = $vs.sortData($event, orders, 'status')">Status</vs-th>
          <vs-th>Action</vs-th>
        </vs-tr>
      </template>

      <template #tbody>
        <vs-tr v-for="order in filteredOrders" :key="order.id" :data="order">
          <vs-td>{{ order.id }}</vs-td>
          <vs-td>{{ order.contents }}</vs-td>
          <vs-td>
            <div v-if="order.status === 'green'" class="circle green"></div>
            <div v-else-if="order.status === 'red'" class="circle red"></div>
          </vs-td>
          <vs-td>
            <router-link :to="`/${order.id}`">View Details</router-link>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  name: 'Orders',

  data() {
    return {
      orders: [],
      filters: [],
      selectedFilter: '',
    };
  },

  computed: {
    filteredOrders() {
      return this.orders.filter((order) => {
        return order.contents.includes(this.selectedFilter);
      });
    },
  },

  created() {
    const orders = this.$store.state.orders;

    orders.forEach((order) => {
      let contents = '';

      order.contents.forEach((item) => {
        if (contents !== '') {
          contents = `${contents}, ${item.qty} ${item.name}`;
        } else {
          contents = `${item.qty} ${item.name}`;
        }

        if (!this.filters.includes(item.name)) {
          this.filters.push(item.name);
        }
      });

      order.contents = contents;
    });

    this.orders = orders;
  },
};
</script>
